export default class Host {
    id = null;
    name = null;
    description = null;
}
